var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"avatar",attrs:{"to":{name: 'user-tweets', params: {id: _vm.initUserId}}}},[_c('figure',[_c('img',{attrs:{"src":_vm.initImage,"alt":"大頭貼"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }